// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"starrating_wrapper__ZirOX","active":"starrating_active__2Y3uv","thanks":"starrating_thanks__RL90z","fadeIn":"starrating_fadeIn__vRoAQ"};